var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.sector.active ? 'semi-card active': 'semi-card',style:({ 'border-color': _vm.sector.color }),on:{"click":_vm.active}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.value.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }